import { useMediaQuery } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useQuery } from 'react-query';

import { useActions } from '../../hooks/useActions';
import { useCard } from '../../hooks/useCard';
import { useReview } from '../../hooks/useReview';
import { useUser } from '../../hooks/useUser';
import { ReviewService } from '../../service/review.service';

export const useReviews = (isAllReviews: boolean = false) => {
  const { catalog_item } = useCard();
  const { profile } = useUser();
  const {
    reviews_comments_data,
    review_comment_id,
    isLikeReview,
    isLikeComment,
    likesReviewData,
    reviewsCommentsCount,
    reviewStarsAvg,
  } = useReview();
  const { setReviewCount, setReviewStars } = useActions();
  const [offsetShowMore, setOffsetShowMore] = useState(0);

  const [isOpenModalForm, setIsOpenModalForm] = useState(false);

  const [review, setReviewItems] = useState<any>([]);
  const [isReviewCount, setIsReviewCount] = useState<boolean>(false);
  const [isAllUploaded, setIsAllUploaded] = useState<boolean>(false);
  const mobileScreen = useMediaQuery('(max-width:539px)');

  const handleShowMore = () => {
    setOffsetShowMore((offset) => offset + 1);
  };

  const handleShowModalForm = () => {
    setIsOpenModalForm(!isOpenModalForm);
  };

  const { isLoading, data } = useQuery(
    ['get review', review_comment_id, offsetShowMore, isLikeReview],
    () =>
      ReviewService.getByCardComment({
        limit: isAllReviews ? 1000 : 5,
        owner_id: catalog_item.id,
        owner_type: 'Catalog::Item',
        offset: offsetShowMore,
      }),
    {
      onSuccess: ({ reviews_comments, reviews_comments_count, stars_avg }) => {
        const checkCopyOldItem = review.some((r: any) => {
          const newItem = reviews_comments.find((item) => item.id === r.id);
          return typeof newItem !== 'undefined';
        });
        if (!checkCopyOldItem) {
          setReviewItems([...review, ...reviews_comments]);
        }
        setReviewCount(reviews_comments_count);
        setReviewStars(stars_avg);
        if (Number(reviews_comments_count) >= 1) {
          setIsReviewCount(true);
        } else {
          setIsReviewCount(false);
        }
      },
      enabled: !!catalog_item.id,
    }
  );
  useEffect(() => {
    const updatedComments = review.map((r: any) =>
      r.id === review_comment_id
        ? {
            ...r,
            dislikes_count: likesReviewData.dislikes_count,
            likes_count: likesReviewData.likes_count,
            is_like_by_me: likesReviewData.is_like_by_me,
          }
        : r
    );
    // Обновляем состояние списка комментариев
    setReviewItems(updatedComments);
  }, [likesReviewData]);

  useEffect(() => {
    if (Number(data?.reviews_comments_count) === review.length) {
      setIsAllUploaded(true);
    }
  }, [data?.reviews_comments_count, review.length, catalog_item.id]);
  const checkUserId = review?.some((c: any) => c.user_id === profile?.id);
  return useMemo(
    () => ({
      isLoading,
      review,
      isReviewCount,
      checkUserId,
      handleShowMore,
      isAllUploaded,
      reviewCount: reviewsCommentsCount,
      stars_avg: reviewStarsAvg,
      mobileScreen,
      handleShowModalForm,
      isOpenModalForm,
    }),
    [
      isLoading,
      reviews_comments_data,
      isReviewCount,
      offsetShowMore,
      checkUserId,
      isAllUploaded,
      review,
      reviewsCommentsCount,
      reviewStarsAvg,
      mobileScreen,
      isOpenModalForm,
    ]
  );
};
